import React from 'react'
import "./midbanner.css"
import config from "../../config";
const Midbanner = () => {
    return (
        <section class="second-mid-banner-section">
            <div class="container">
                <div class="second-mid-banner-section-wrapper">
                    <h2>Stop Managing Sprints Manually & Start Scaling with AgentScrum</h2>
                    <p>Automate daily standups, backlog grooming, sprint tracking, and team reporting—without the chaos. Save time, eliminate blockers faster, and deliver better with intelligent Scrum automation built for modern teams.</p>
                    <div class="second-mid-banner-button">
                        <a href={config.bookdemo.Link}>
                            <p>Book Demo</p>
                        </a>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Midbanner